import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';

import { TrafficChart } from '../TrafficChart';
import { RequestsChart } from '../RequestsChart';

export const Chart = () => {
  const { chainCallProtocol } = useChainSelectors();

  const isGRPC = chainCallProtocol === 'grpc';

  return isGRPC ? <TrafficChart /> : <RequestsChart />;
};
